export class ResetPasswordModel {
    UserName = '';
    userid = '';
    password = '';
    confirmpassword = '';
    code = '';
    actionType = '';
    
}

export class ForgotPasswordModel {
    UserName = '';
}
